/**
 * Calculates estimated reading time for an article based on content and/or excerpt.
 * Standard metric: 200 words per minute.
 */
export function getReadingTime(content?: string, excerpt?: string): string {
  const source = content || excerpt || '';
  if (!source) return '1 min de leitura';
  
  // Strip HTML tags if present
  const cleanText = source.replace(/<[^>]*>?/gm, '');
  const words = cleanText.trim().split(/\s+/).filter(Boolean);
  const minutes = Math.max(1, Math.ceil(words.length / 200));
  
  return `${minutes} min de leitura`;
}
